export const Theme = {
  primaryColor: "#0511a5",
  primaryColorRgb: "227, 27, 115",
  primaryColorContrast: "#e0e1ea",
  primaryColorContrastRgb: "255, 255, 255",
  primaryColorShade: "#040f91",
  primaryColorTint: "#1e29ae",
  secondaryColor: "#e31b73",
  secondaryColorRgb: "5, 17, 165",
  secondaryColorContrast: "#ffffff",
  secondaryColorContrastRgb: "255, 255, 255",
  secondaryColorShade: "#c81865",
  secondaryColorTint: "#e63281",
  toolbarColor: "#e31b73",
  toolbarBackgroundColor: "#ffffff",
  toolbarBackgroundColorConstrast: "#ffffff",
  homePageCategorySize: "64px",
  categoryIconPadding: "20px 20px 15px 20px",
  categoryIconSize: "90px",
  headerLogoWidthMinimized: "40px",
  headerLogoWidth: "60px",
  borderRadiusValue: "10px",
  borderRadiusProductValue: "12px",
  colorSectionsValue: "#21212c",
  colorNewProduct: "#e83bef",
  transformScaleValueCategory: "scale(2)",
  transformScaleValue: "scale(1.5)",
  borderRadiusButtonValue: "6px",
  borderRadiusInputValue: "6px",
  borderRadiusCardValue: "4px",
  borderShadowNewListProduct: "4px 3px 3px rgba(36, 36, 46, 0.1)",
  borderRadiusNewListValue: "12px",
  cardBorderValue: "1px solid #e0e1ea",
  borderProductNewListBottom: "none",
  colorLightContrast: "#000",
  headerLogoHeightMinimized: "40px",
  borderRadiusToolbarValue: "0px 0px 12px 12px",
  dangerColor: "#eb445a",
  dangerColorRgb: "235, 68, 90",
  dangerColorContrast: "#ffffff",
  dangerColorContrastRgb: "255, 255, 255",
  dangerColorShade: "#cf3c4f",
  dangerColorTint: "#ed576b",

  lightColor: "#e0e1ea",
  lightColorShade: "#c5c6ce",
  lightColorContrast: "#000",
  lightColorTint: "#e3e4ec",
  lightColorRgb: "224, 225, 234",
  lightColorContrastRgb: "0, 0, 0",

  mediumColor: "#b9bac7",
  mediumColorShade: "#a3a4af",
  mediumColorRgb: "185, 186, 199",
  mediumColorContrast: "#000",
  mediumColorTint: "#c0c1cd",
  mediumColorContrastRgb: "0, 0, 0",

  successColor: "#00d933",
  successColorRgb: "0, 217, 51",
  successColorContrast: "#000000",
  successColorContrastRgb: "0, 0, 0",
  successColorShade: "#00bf2d",
  successColorTint: "#1add47",

  warningColor: "#ffc409",
  warningColorRgb: "255, 169, 9",
  warningColorContrast: "#000",
  warningColorContrastRgb: "255, 255, 255",
  warningColorShade: "#cf3c4f",
  warningColorTint: "#ed576b",
};
